import script from "./AutofillReviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AutofillReviewPanel.vue?vue&type=script&setup=true&lang=js"

import "./AutofillReviewPanel.vue?vue&type=style&index=0&id=ff4b102c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff4b102c"]])

export default __exports__